<!--分数评定 SCORE-->
<template>
  <div class="question-editor">
    <div class="question-pd">
      <div class="question-header">
        <div class="question-header-left">
          <div>
            <span class="question-number">{{ `${index + 1}、` }}</span>
          </div>
          <!-- <div class="question-select"></div>
          <div class="question-select"></div> -->
          <div style="display: flex; align-items: center; margin-left: 10px">
            <div class="select-box">
              <p style="font-size: 14px; margin-right: 5px">起始分数：</p>
              <el-select
                v-model="minScore"
                placeholder="请选择"
                size="mini"
                style="
                  border: 1px solid #dcdde0;
                  border-radius: 3px;
                  width: 100px;
                "
              >
                <el-option
                  v-for="score in styleColumns"
                  :key="score.id"
                  :label="score.label"
                  :value="score.id"
                ></el-option>
              </el-select>
            </div>
            <div class="select-box">
              <p style="font-size: 14px; margin-right: 5px; margin-left: 5px">
                测评数量：
              </p>
              <el-select
                v-model="scoreNum"
                placeholder="请选择"
                size="mini"
                style="
                  border: 1px solid #dcdde0;
                  border-radius: 3px;
                  width: 100px;
                "
              >
                <el-option
                  v-for="score in scoreColumns"
                  :key="score.id"
                  :label="score.label"
                  :value="score.id"
                ></el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div class="question-header-right">
          <img
            v-if="type === 1"
            src="https://ossfastmake.mustke.com/qrCode/tupian/1755596666801.png"
            class="image-up"
            @click="handleOperateClick(2)"
          />
          <img
            v-if="type === 1"
            src="https://ossfastmake.mustke.com/qrCode/tupian/1755596715787.png"
            class="image-down"
            @click="handleOperateClick(3)"
          />
          <img
            v-if="type === 1"
            src="https://ossfastmake.mustke.com/qrCode/tupian/1755596748508.png"
            class="image-delete"
            @click="handleOperateClick(4)"
          />
        </div>
      </div>
      <div
        class="textarea-box"
        style="
          width: 100%;
          background: #ffffff;
          border: 1px solid #dcdde0;
          border-radius: 4px;
          padding: 12px;
          box-sizing: border-box;
          margin-top: 10px;
        "
      >
        <!-- <textarea
          v-model="caseProblem"
          placeholder="请给本项打分"
          maxlength="500"
          @input="handleInput"
          @focus="isFocusIndex = '-1'"
          @blur="isFocusIndex = ''"
          rows="2"
          style="width: 100%; resize: none"
        ></textarea>
        <div
          style="
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 8px;
          "
        >
          <img
            src="https://ossfastmake.mustke.com/qrCode/tupian/1737857957020.png"
            style="width: 18px; height: 18px; cursor: pointer"
            @click="handleCaseProblemImg"
          />
          <div @click="clearQuestion" class="clear-btn">清空</div>
        </div> -->

        <MyEditor
          v-model="caseProblem"
          @insertImg="handleCaseProblemImg"
          @input="handleInput"
        />
      </div>
      <div class="question-images">
        <div
          v-for="(item, index) in images"
          :key="index"
          style="margin-top: 10px; position: relative"
        >
          <img :src="item" style="width: 100%" />
          <img
            src="@/assets/images/guanbi.png"
            class="guanbi"
            @click="handleDeleteQuestionImage(index)"
          />
        </div>
      </div>
    </div>

    <div style="width: 100%; padding: 0 25px">
      <div v-for="(item, index) in list" :key="index" class="item">
        <div
          style="
            display: flex;
            justify-content: space-between;
            align-items: center;
          "
        >
          <span style="display: block; flex-grow: 1"></span>
          <i class="el-icon-delete" @click="delItem(index)"></i>
        </div>
        <div class="option-item-bottom-input" style="border: 1px solid #dcdde0">
          <input
            type="text"
            :placeholder="'打分项' + (index + 1)"
            v-model="item.text"
            @focus="inputFocusIndex = `a${index}`"
            @blur="inputFocusIndex = ''"
          />
        </div>
        <div class="score-view">
          <div
            v-for="(s, i) in scoreNum"
            :key="i"
            class="score-view-item-inactive"
          >
            {{ minScore + i }}
          </div>
        </div>
        <div class="rating">
          <div class="rating-item" style="border: 1px solid #dcdde0">
            <input
              type="text"
              placeholder="编辑提示词"
              v-model="item.ratingArr[0]"
            />
          </div>
          <div class="rating-item" style="border: 1px solid #dcdde0">
            <input
              type="text"
              placeholder="编辑提示词"
              v-model="item.ratingArr[1]"
            />
          </div>
          <div class="rating-item" style="border: 1px solid #dcdde0">
            <input
              type="text"
              placeholder="编辑提示词"
              v-model="item.ratingArr[2]"
            />
          </div>
        </div>
      </div>
      <div v-if="ifElseConfig" class="rating">
        <div class="rating-item" style="border: 1px solid #dcdde0">
          <input type="text" placeholder="编辑提示词" v-model="value1" />
        </div>
        <div class="rating-item" style="border: 1px solid #dcdde0">
          <input type="text" placeholder="编辑提示词" v-model="value2" />
        </div>
        <div class="rating-item" style="border: 1px solid #dcdde0">
          <input type="text" placeholder="编辑提示词" v-model="value3" />
        </div>
      </div>

      <div class="add-view" style="margin-top: 10px">
        <div class="add-batch custom-check-box" style="color: #ffffff">
          <el-checkbox
            label="必选题"
            v-model="isMust"
            :true-label="1"
            :false-label="0"
            class="custom-checkbox"
            @change="handleCheckboxChange"
          ></el-checkbox>
        </div>
        <div @click="addOption" class="add-btn">
          <img
            src="https://ossfastmake.mustke.com/qrCode/tupian/1737858857723.png"
            style="width: 13px; height: 13px"
          />
          <span>添加选项 {{ list.length + "/50" }}</span>
        </div>
        <div class="add-batch custom-check-box" style="color: #ffffff">
          批量添加
        </div>
      </div>
    </div>
    <div class="option-settings" style="margin-top: 10px">
      <div class="question-header-right">
        <div class="add-batch">
          <span>分值：{{ totalScore }}分</span>
        </div>
      </div>
      <div></div>
    </div>
    <div v-if="type === 1" class="question-footer">
      <div class="save-btn" @click.stop="saveClick">保存</div>
    </div>
    <input type="file" ref="fileInput" accept="image/*" style="display: none" />
  </div>
</template>

<script>
import PopupInput from "@/components/PopupInput/PopupInput.vue";
import axios from "axios";
import baseURL from "../../utils/bsaeUrl";
export default {
  components: { PopupInput },
  props: {
    params: { type: Object, default: () => ({}) },
    uuid: { type: String, default: "" },
    index: { type: Number, default: 0 },
    type: { type: Number, default: 1 },
    updateType: { type: Number, default: 0 },
  },
  data() {
    return {
      list: [],
      dataObj: {},
      ifRandomize: false,
      isMust: false,
      uploadIndex: 0,
      images: [],
      caseProblem: "",
      isFocusIndex: "",
      inputFocusIndex: "",
      minScore: 1,
      scoreNum: 2,
      value1: "",
      value2: "",
      value3: "",
      styleColumns: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((n) => ({
        id: n,
        label: String(n),
      })),
      scoreColumns: [2, 3, 4, 5, 6, 7, 8, 9, 10].map((n) => ({
        id: n,
        label: String(n),
      })),
      ifElseConfig: false,
      totalScore: 0,
    };
  },
  methods: {
    handleFileChange(event) {
      const file = event.target.files[0];
      const formData = new FormData();
      formData.append("file", file);
      formData.append("uuid", this.uuid);
      this.$refs.fileInput.value = "";
      axios
        .post(baseURL + "/PCwj/file/uploads", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            token: localStorage.getItem("token"),
          },
        })
        .then((response) => {
          this.$message.success("上传成功！");
          if (this.uploadIndex === -1) {
            this.images = [response.data.urls];
          } else {
            this.list[this.uploadIndex].img_path = [response.data.urls];
          }
          this.handleUpdateQuestion();
        })
        .catch((error) => {
          if (!axios.isCancel(error)) this.$message.error("上传失败！");
        });
    },
    handleOperateClick(type) {
      this.$emit("operate", JSON.stringify({ type, index: this.index }));
    },
    handleInput() {
      this.handleUpdateQuestion();
    },
    clearQuestion() {
      this.caseProblem = "";
      this.handleUpdateQuestion();
    },
    addOption() {
      if (this.list.length < 50) {
        this.list.push({
          text: "",
          ratingArr: ["非常不满意", "一般", "非常满意"],
          newDate: true,
        });
      } else {
        this.$message.error("最多只能添加50个选项");
      }
      this.handleUpdateQuestion();
    },
    delItem(index) {
      if (this.updateType === 1) {
        if (this.list[index].newDate) {
          this.list.splice(index, 1);
        } else {
          this.$message.error("限制性修改状态下，不能删除之前的数据!");
        }
      } else {
        this.list.splice(index, 1);
      }
      this.handleUpdateQuestion();
    },
    handleCaseProblemImg() {
      this.uploadIndex = -1;
      this.$refs.fileInput.click();
    },
    handleDeleteQuestionImage(index) {
      this.images.splice(index, 1);
      this.handleUpdateQuestion();
    },
    handleCheckboxChange() {
      this.handleUpdateQuestion();
    },
    handleUpdateQuestion() {
      this.dataObj.isMust = this.isMust ? 1 : 0;
      this.dataObj.caseProblemImg = JSON.stringify(this.images);
      this.dataObj.ifRandomize = this.ifRandomize ? 1 : 0;
      this.dataObj.caseProblem = this.caseProblem;
      this.dataObj.questionScore = this.totalScore;
      this.dataObj.chooseList = JSON.stringify({
        list: this.list.map((item) => {
          item.is_fill = item.is_fill ? 1 : 0;
          return item;
        }),
      });
      this.dataObj.scoreNum = this.scoreNum;
      this.dataObj.minScore = this.minScore;
      this.$emit(
        "update",
        JSON.stringify({ index: this.index, data: this.dataObj }),
      );
    },
    saveClick() {
      if (this.caseProblem.includes(" ") && this.caseProblem.trim() === "") {
        this.$message.error("请输入题目");
      }
      this.dataObj.isMust = this.isMust ? 1 : 0;
      this.dataObj.caseProblemImg = JSON.stringify(this.images);
      this.dataObj.ifRandomize = this.ifRandomize ? 1 : 0;
      this.dataObj.caseProblem =
        this.caseProblem === "" ? "请给本项打分" : this.caseProblem;
      this.dataObj.chooseList = JSON.stringify({
        list: this.list.map((item, i) => {
          item.is_fill = item.is_fill ? 1 : 0;
          item.text = item.text === "" ? `打分项${i + 1}` : item.text;
          return item;
        }),
      });
      this.dataObj.scoreNum = this.scoreNum;
      this.dataObj.minScore = this.minScore;
      this.dataObj.questionScore = this.totalScore;
      this.$emit(
        "save",
        JSON.stringify({ index: this.index, data: this.dataObj }),
      );
    },
  },
  watch: {
    params: {
      handler(newVal) {
        this.dataObj = newVal;
        this.caseProblem = newVal.caseProblem;
        this.list = JSON.parse(newVal.chooseList).list.map((item) => {
          item.is_fill = item.is_fill === 1;
          return item;
        });
        this.ifRandomize = newVal.ifRandomize === 1;
        this.isMust = newVal.isMust === 1;
        this.images = JSON.parse(newVal.caseProblemImg);
        this.scoreNum = newVal.scoreNum;
        this.minScore = newVal.minScore;
        this.totalScore =
          (this.minScore + this.scoreNum - 1) * this.list.length;
        if (newVal.elseConfig) {
          this.ifElseConfig = true;
          this.value1 = JSON.parse(newVal.elseConfig)[0];
          this.value2 = JSON.parse(newVal.elseConfig)[1];
          this.value3 = JSON.parse(newVal.elseConfig)[2];
        }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style scoped>
.add-view {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.question-header-left {
  display: flex;
  align-items: center;
}
.question-header-right {
  display: flex;
  align-items: center;
}
.option-item-top-right input {
  color: #4c4a56;
}
.textarea-box textarea {
  color: #4c4a56;
}
.item {
  width: 100%;
  background: #f8f8f8;
  border: 1px dashed #3a60ff;
  border-radius: 4px;
  padding: 10px 25px;
  box-sizing: border-box;
  margin-top: 10px;
}
.rating {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
}
.rating-item {
  width: 170px;
  height: 33px;
  background: #ffffff;
  border: 1px solid #ededed;
  border-radius: 3px;
  display: flex;
  align-items: center;
  padding: 0 13px;
  box-sizing: border-box;
}
.rating-item input {
  width: 100%;
  height: 100%;
  border: none;
  box-sizing: border-box;
  font-size: 13px;
  text-align: center;
}
.score-view {
  margin-top: 15px;
  display: flex;
  justify-content: space-between;
}
.score-view-item-inactive {
  width: 27px;
  height: 27px;
  line-height: 27px;
  border: 1px solid #dcdde0;
  background-color: #f9f9f9;
  color: #2b2f36;
  font-size: 14px;
  font-weight: 400;
  text-align: center;
  border-radius: 15px;
}
.select-box {
  display: flex;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/EvaluationEdit/EvaluationEditScore.vue